module.exports = __webpack_public_path__ + "static/media/Ravi.9a107d32.png";